export default "../media/award_icon.c19ee1c0ebefd15e2dfb42821910ebbf.svg";